const ssoEndpoints = {
   exchange: 'sso/exchange/'
}

export default ssoEndpoints
